module.exports = __webpack_public_path__ + "img/activity02.605be105.png";